var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCoolDown = function SvgArrowCoolDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.998 20.7-6.15-6.15.475-.5 5.325 5.325v-7.1h.7V19.4l5.325-5.325.475.475zm-.35-10.425v-3h.7v3zm0-5v-2h.7v2z"
  })));
};
export default SvgArrowCoolDown;